export const searchValueCheck = (searchValue: string) =>
  searchValue.length >= 3;
